import React,{Component} from 'react';
import {Router, Route, Redirect, Switch} from 'react-router-dom';

import { history } from '../history/history';

import GSuitAuth from '../components/admin/login/login';
import Campaign from '../components/admin/manageCampaign/main';
import Reconsilation from '../components/admin/manageCampaign/reconcilation';
import FailedCampaigns from '../components/admin/manageCampaign/failedcampaigns';
import DeletedCampaigns from '../components/admin/manageCampaign/deletedcampaigns';
import '../../assets/css/style1.scss'
import {AuthAdmin} from '../components/common/AuthGaurd';
import RateCard from '../components/admin/managerateCard/index';
import FrequencyPackage from '../components/admin/manageCampaign/managePackage.js/frequency';
import DayPackage from '../components/admin/manageCampaign/managePackage.js/dayPackage';
import Discounts from '../components/admin/manageCampaign/managePackage.js/discounts'
import User from '../components/admin/userManagement/index';
import SalesUserPerformance from '../components/admin/userManagement/salesUserPerformance';
import ContactUs from '../components/admin/contactUs/index';
import leaddashboard from '../components/admin/contactUs/leaddashboard';
import Enquiry from '../components/admin/contactUs/enquiry';
import Loader from '../components/common/Loader';
import ApprovedMain from '../components/admin/manageCampaign/approvedMain';
import budgetPackage from '../components/admin/manageCampaign/managePackage.js/budgetPackage';
import manageCoupon from '../components/admin/manageCoupon';
import AuditAdminCampaign from '../components/admin/audit_management/index'

import AdminComp from '../components/admin/admin_management/AdminComp';

import SalesUsersListComp from '../components/admin/users/salesUser/SalesUsersList';
import CampaignsListComp from '../components/admin/users/salesUser/CampaignsList';

import ViewCampaignComp from '../components/admin/users/salesUser/ViewCampaign';

import EditClusterComp from '../components/admin/users/salesUser/editCluster';
import editClusterofCluster from '../components/admin/users/salesUser/editClusterofCluster';
import ViewClusterComp from '../components/admin/users/salesUser/viewCluster';


import Error from '../components/admin/common/Error';
import AddCluster from '../components/admin/users/salesUser/AddCluster';
import AddClusterOfCluster from '../components/admin/users/salesUser/AddClusterOfCluster';
import Clusterlist from '../components/admin/users/salesUser/Clusterlist';
import clusterOfClusterlist from '../components/admin/users/salesUser/clusterOfClusterlist';
import audiomanagment from '../components/admin/audioadminmanagment/audiomanagment';
// import AudioAdminComp  from '../components/admin/audioadminmanagment/AudioAdminComp';
import ViewAudiolistComp from '../components/admin/audioadminmanagment/ViewAudiolist';

import UploadAudiolistComp from '../components/admin/audioadminmanagment/UploadAudiolist';
import audioRequestManagement from "../components/admin/audioadminmanagment/audioRequestManagement";
import trackcoupon from '../components/admin/manageCoupon/trackcoupon';
import requestcoupon from '../components/admin/manageCoupon/requestcoupon';
import requestnonfctcode from '../components/admin/manageCoupon/requestnonfctcode';
import createrequestCoupon from '../components/admin/manageCoupon/createrequestCoupon';
import createrequestNonFCTCode from '../components/admin/manageCoupon/createrequestNonFCTCode';
import nonFCTCode from '../components/admin/manageCoupon/nonFCTCodes';
import DsaComp from "../components/admin/dsa_management/index"
import dsaconfigration from '../components/admin/dsa_management/dsaconfigration';
import incentive from '../components/admin/dsa_management/incentive';
import dsaincentives from '../components/admin/dsa_management/dsaincentives';
import Notification from "../components/admin/manageNotification"
import broadcastmanagement from "../components/admin/manageNotification/list"
import requestDeleteDSA from '../components/admin/dsa_management/requestDeleteDSA';
import roleAccessControl from '../components/admin/rolemanagement/roleAccessControl';
import SplashScreen from '../components/admin/home/splashscreen';
import OnlineOfflineSalesReport from '../components/admin/reports/onlineoffline';
import roles from '../components/admin/rolemanagement/roles';

class AdminRoutes extends Component {
  constructor(props) {
    super(props);
  }

  render() { 
    const { match } = this.props;
    return (
      <Router history= {history}>
        <div className="admin">
          <Loader/>
          <Error />
          <Switch>
            <Route  path={`${match.url}/login`} component={GSuitAuth} /> 
            <AuthAdmin path={`${match.url}/admins`} component={AdminComp} />
            <AuthAdmin path={`${match.url}/user`} component={User} />
            <AuthAdmin path={`${match.url}/userperformance`} component={SalesUserPerformance} />

            <AuthAdmin exact path={`${match.url}/salesuser`} component={SalesUsersListComp} />
            <AuthAdmin exact path={`${match.url}/salesuser/campaigns`} component={CampaignsListComp} />
            <AuthAdmin exact path={`${match.url}/clusterList`} component={Clusterlist} />
            <AuthAdmin exact path={`${match.url}/clusterOfClusterlist`} component={clusterOfClusterlist} />
            <AuthAdmin exact path={`${match.url}/audioadminmanagment/audiomanagment`} component={audiomanagment} />
            <AuthAdmin exact path={`${match.url}/audioRequestManagement`} component={audioRequestManagement} />

            {/* <AuthAdmin exact path={`${match.url}/audioadminmanagment/AudioAdminComp`} component={AudioAdminComp} /> */}


            <AuthAdmin exact path={`${match.url}/clusterlist/clusterEdit`} component={EditClusterComp} />
            <AuthAdmin exact path={`${match.url}/clusterOfClusterlist/clusterofClusterEdit`} component={editClusterofCluster} />

            <AuthAdmin exact path={`${match.url}/clusterlist/clusterView`} component={ViewClusterComp} />

            {/* <AuthAdmin exact path={`${match.url}/audioadminmanagment/ViewAudiolist`} component={ViewAudiolistComp} /> */}

            <AuthAdmin exact path={`${match.url}/audioadminmanagment/UploadAudiolist`} component={UploadAudiolistComp} />

            <AuthAdmin exact path={`${match.url}/clusterlist/addCluster`} component={AddCluster} />
            <AuthAdmin exact path={`${match.url}/clusterOfClusterlist/addClusterOfCluster`} component={AddClusterOfCluster} />

            <AuthAdmin exact path={`${match.url}/salesuser/campaign/view`} component={ViewCampaignComp} />

            <AuthAdmin path={`${match.url}/campaign`} component={Campaign} />
            <AuthAdmin path={`${match.url}/reconciliation`} component={Reconsilation} />
            <AuthAdmin path={`${match.url}/failedcampaigns`} component={FailedCampaigns} />
            <AuthAdmin path={`${match.url}/deletedcampaigns`} component={DeletedCampaigns} />
            
            <AuthAdmin path={`${match.url}/campaigns/approved`} component={ApprovedMain} /> 
            <AuthAdmin path={`${match.url}/package/frequency`} component={FrequencyPackage} />
            <AuthAdmin path={`${match.url}/package/day`} component={DayPackage} />
            <AuthAdmin path={`${match.url}/package/budget`} component={budgetPackage} />
            <AuthAdmin path={`${match.url}/rate-card`} component={RateCard} />   
            <AuthAdmin path={`${match.url}/package/discounts`} component={Discounts} />   
            <AuthAdmin path={`${match.url}/contact`} component={ContactUs} />
            <AuthAdmin path={`${match.url}/leaddashboard`} component={leaddashboard} />
            <AuthAdmin path={`${match.url}/enquiry`} component={Enquiry} />
            <AuthAdmin path={`${match.url}/coupons`} component={manageCoupon} />    
            <AuthAdmin path={`${match.url}/trackcoupons`} component={trackcoupon} />
            <AuthAdmin path={`${match.url}/tp`} component={DsaComp} />    
            <AuthAdmin path={`${match.url}/dsaconf`} component={dsaconfigration} /> 
            <AuthAdmin path={`${match.url}/incentives`} component={incentive} /> 
            <AuthAdmin path={`${match.url}/dsaincentives`} component={dsaincentives} /> 
            <AuthAdmin path={`${match.url}/auditcampaigns`} component={AuditAdminCampaign} /> 
            <AuthAdmin path={`${match.url}/requestcoupons`} component={requestcoupon} /> 
            <AuthAdmin path={`${match.url}/couponrequest`} component={createrequestCoupon} /> 
            <AuthAdmin path={`${match.url}/nonfctcoderequest`} component={createrequestNonFCTCode} /> 
            <AuthAdmin path={`${match.url}/requestnonfctcode`} component={requestnonfctcode} /> 
            <AuthAdmin path={`${match.url}/nonfctcode`} component={nonFCTCode} /> 
            <AuthAdmin path={`${match.url}/notification`} component={Notification} /> 
            <AuthAdmin path={`${match.url}/notificationlist`} component={broadcastmanagement} /> 
            <AuthAdmin path={`${match.url}/dsa-delete-request`} component={requestDeleteDSA} /> 
            <AuthAdmin path={`${match.url}/role-access-control`} component={roleAccessControl} /> 
            <AuthAdmin path={`${match.url}/splash_screen`} component={SplashScreen} /> 
            <AuthAdmin path={`${match.url}/sales-medium-report`} component={OnlineOfflineSalesReport} /> 
            {/* <AuthAdmin path={`${match.url}/roles`} component={roles} />  */}
          </Switch>
        </div>
      </Router>
    )
  }
}
export default AdminRoutes;


// WEBPACK FOOTER //
// ./web/routes/adminRoutes.js